import { MimeType } from 'src/models/MimeType.model';

import { validatePdfFile } from './validatePdfFile';

export const fetchPdfFile = async (
  reportFileUrl: string,
): Promise<{ blob: Blob; blobUrl: string }> => {
  const response = await fetch(reportFileUrl, {
    method: 'GET',
    headers: {
      Accept: MimeType.PDF,
    },
    credentials: 'same-origin',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch PDF: ${response.statusText}`);
  }

  let blob = await response.blob();

  const validTypes: string[] = [MimeType.PDF, MimeType.OCTET_STREAM];
  if (!validTypes.includes(blob.type)) {
    throw new Error(`Expected PDF file but received ${blob.type}.`);
  }

  await validatePdfFile(blob);

  if (blob.type !== MimeType.PDF) {
    blob = new Blob([blob], { type: MimeType.PDF });
  }

  const blobUrl = URL.createObjectURL(blob);

  return { blob, blobUrl };
};
